export const isStudentUser = (user) => user?.role === "student";

export const getAnalyticsConsent = (user) => Boolean(user?.dataUse);

// All users can be tracked as long as they consent and PII is scrubbed
export const canTrackMixpanel = (user, options = {}) => {
  if (options.allowAnonymous && !user) {
    return true;
  }
  if (options.allowWithoutConsent) {
    return true;
  }
  return getAnalyticsConsent(user);
};
